export default __webpack_public_path__ + "images/b4601b6ac8ea0532d94b4e1c0a44c154-back-arrow.svg";